//   @flow

import React from 'react';
import {Grid, Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
// import PricesFilterItem from '../FilterItem/PricesFilterItem/PricesFilterItem';
import PromotionsFiltersItem from '../FilterItem/PromotionsFilterItem/PromotionsFilterItem';
import VariantsFilterItem from '../FilterItem/VariantsFilterItem/VariantsFilterItem';

const useStyles = makeStyles(theme => ({
  title: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
  },
  container: {
    margin: theme.spacing(2, 0),
    maxWidth: '100%',
  },
}));
function FiltersList() {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.title}>
        Selecciona los filtros que quieres mostrar en tus páginas de
        categoría/colecciones
      </Typography>

      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12}>
          <VariantsFilterItem />
        </Grid>
        {/* <Grid item xs={12}>
          <PricesFilterItem />
        </Grid> */}
        <Grid item xs={12}>
          <PromotionsFiltersItem />
        </Grid>
      </Grid>
    </div>
  );
}

export default FiltersList;
